import { computed, ref, watch } from "vue";
import { useDark } from "@vueuse/core";
import { isEmbedded } from "@/remote/contract";
// Temporarily disabled for theme migration
// import { usePreferredDark } from "@vueuse/core";
// import { useCookies } from "@vueuse/integrations/useCookies";
// import { useRouter } from "vue-router";

import { THEME } from "@/constants";
// import { getBasePath } from "@/config/runtimeConfig";

export const useTheme = () => {
  // Temporarily disabled for theme migration
  // const THEME_KEY = "user-preferred-theme";

  // const COOCKIE_SETTINGS = {
  //   path: getBasePath(),
  //   maxAge: 365 * 86400,
  // };

  // const cookies = useCookies();
  // const isSystemPreferredDark = usePreferredDark();

  // TEMPORARY: Force light mode during theme migration
  const userPrefferedTheme = ref(THEME.LIGHT);
  // const userPrefferedTheme = ref(cookies.get(THEME_KEY) || THEME.SYSTEM);

  // Embedded, the HOST owns <html data-theme> and the shared
  // 'vueuse-color-scheme' localStorage key. Constructing useDark WRITES both
  // (its immediate watcher applies the stored/os value, and the forced-light
  // watch below would then stomp a dark host) — found live in the csiq shell,
  // and reintroduced once via an unguarded useTheme() in ThreatCoach.vue, so
  // the guard lives HERE, for every caller. Read-only when embedded.
  if (isEmbedded()) {
    const isThemeDark = computed(
      () => document.documentElement.getAttribute("data-theme") === "dark",
    );
    return {
      isThemeDark,
      userPrefferedTheme,
      setUserPreferredTheme: () => {},
    };
  }

  const isThemeDark = useDark({
    selector: "html",
    attribute: "data-theme",
    valueDark: "dark",
    valueLight: "light",
  });

  const setUserPreferredTheme = (_theme) => {
    // TEMPORARY: Ignore theme changes during migration
    // Disabled console warning to pass linting
    // console.warn("Theme switching temporarily disabled during migration");
    return;

    // Original code (commented out)
    // userPrefferedTheme.value = theme;
    // cookies.set(THEME_KEY, theme, COOCKIE_SETTINGS);
    // const router = useRouter();
    // router.go(0);
  };

  watch(
    () => userPrefferedTheme.value,
    () => {
      // TEMPORARY: Always force light mode
      isThemeDark.value = false;

      // Original code (commented out)
      // if (userPrefferedTheme.value === THEME.SYSTEM) {
      //   isThemeDark.value = isSystemPreferredDark.value;
      // }
      // if (userPrefferedTheme.value === THEME.DARK) {
      //   isThemeDark.value = true;
      // }
      // if (userPrefferedTheme.value === THEME.LIGHT) {
      //   isThemeDark.value = false;
      // }
    },
    { immediate: true },
  );

  return {
    isThemeDark,
    userPrefferedTheme,
    setUserPreferredTheme,
  };
};

export default {};
